import React from 'react';
import styled from 'styled-components';
import { Token } from '@usealloy/component-library';
import { routes } from '~/helpers/routes';

type WorkflowAndEvaluationCellsProps = {
  workflowToken: string;
  workflowVersion: number;
  workflowName: string;
  evaluationToken: string;
};

const Link = styled.a`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const WorkflowAndEvaluationCells = ({
  workflowToken,
  workflowVersion,
  workflowName,
  evaluationToken,
}: WorkflowAndEvaluationCellsProps) => (
  <>
    <td>
      <Link
        className="secondary m-0"
        href={routes.applications.versions.update(workflowToken, workflowVersion)}
        rel="noreferrer"
        target="_blank"
      >
        {workflowName} v.{workflowVersion}
      </Link>
    </td>
    <td>
      <Token displayContent={evaluationToken} />
    </td>
  </>
);

export default WorkflowAndEvaluationCells;
